import Header from "./components/Header"
import Signup from "./components/Signup"
import Main from "./components/Main"
import { useState } from 'react'

const App = () => {
  const [user, setUser] = useState(null)
  
  return (
    <div className = "App">
      <Header />
        {user === null ?  
          <Signup setUser={setUser}/> : 
          <Main user={user} setUser={setUser}/>}
      <footer className = "footer"></footer>
    </div>
  )
}

export default App